export default {
    "DE-FRA-01": {
        ZeichnungsscheinMenu: "Stand 04/2020 - PDF - 1 MB",
        RisikenMenu: "Stand 04/2020 - PDF - 203 KB",
        EffectaKostenundZuwendungenMenu: "Stand 04/2020 - PDF - 116 KB",
        BasisinformationsblattMenu: "Stand 04/2020 - PDF - 104 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 04/2020 - PDF - 314 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-B-01": {
        ZeichnungsscheinMenu: "Stand 09/2020 - PDF - 1 MB",
        RisikenMenu: "Stand 09/2020 - PDF - 203 KB",
        EffectaKostenundZuwendungenMenu: "Stand 09/2020 - PDF - 116 KB",
        BasisinformationsblattMenu: "Stand 09/2020 - PDF - 104 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 09/2020 - PDF - 314 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-HH-03": {
        ZeichnungsscheinMenu: "Stand 12/2020 - PDF - 500 KB",
        RisikenMenu: "Stand 12/2020 - PDF - 181 KB",
        EffectaKostenundZuwendungenMenu: "Stand 12/2020 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 12/2020 - PDF - 211 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 12/2020 - PDF - 419 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-HH-04": {
        ZeichnungsscheinMenu: "Stand 03/2021 - PDF - 519 KB",
        RisikenMenu: "Stand 03/2021 - PDF - 126 KB",
        EffectaKostenundZuwendungenMenu: "Stand 03/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 03/2021 - PDF - 211 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 03/2021 - PDF - 410 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-K-01": {
        ZeichnungsscheinMenu: "Stand 03/2021 - PDF - 510 KB",
        RisikenMenu: "Stand 03/2021 - PDF - 333 KB",
        EffectaKostenundZuwendungenMenu: "Stand 03/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 03/2021 - PDF - 214 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 03/2021 - PDF - 410 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "ES-MA-01": {
        ZeichnungsscheinMenu: "Stand 05/2021 - PDF - 524 KB",
        RisikenMenu: "Stand 05/2021 - PDF - 181 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 05/2021 - PDF - 105 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 05/2021 - PDF - 219 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "CD-PP-ES-MA-01": {
        ZeichnungsscheinMenu: "Stand 05/2021 - PDF - 537 KB",
        RisikenMenu: "Stand 05/2021 - PDF - 180 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 05/2021 - PDF - 106 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 05/2021 - PDF - 246 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "CD-PP-ES-MA-02": {
        ZeichnungsscheinMenu: "Stand 05/2021 - PDF - 537 KB",
        RisikenMenu: "Stand 05/2021 - PDF - 180 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 05/2021 - PDF - 105 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 05/2021 - PDF - 247 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-HH-06": {
        ZeichnungsscheinMenu: "Stand 07/2021 - PDF - 520 KB",
        RisikenMenu: "Stand 07/2021 - PDF - 130 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2021 - PDF - 213 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2021 - PDF - 409 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-B-02": {
        ZeichnungsscheinMenu: "Stand 08/2021 - PDF - 519 KB",
        RisikenMenu: "Stand 08/2021 - PDF - 134 KB",
        EffectaKostenundZuwendungenMenu: "Stand 08/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 08/2021 - PDF - 212 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 08/2021 - PDF - 408 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-HH-07": {
        ZeichnungsscheinMenu: "Stand 09/2021 - PDF - 523 KB",
        RisikenMenu: "Stand 09/2021 - PDF - 134 KB",
        EffectaKostenundZuwendungenMenu: "Stand 09/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 09/2021 - PDF - 213 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 09/2021 - PDF - 408 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "GB-AW-01": {
        ZeichnungsscheinMenu: "Stand 12/2020 - PDF - 2 MB",
        RisikenMenu: "Stand 12/2020 - PDF - 379 KB",
        EffectaKostenundZuwendungenMenu: "Stand 12/2020 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 12/2020 - PDF - 210 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 12/2020 - PDF - 276 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-GU-01": {
        ZeichnungsscheinMenu: "Stand 02/2021 - PDF - 568 KB",
        RisikenMenu: "Stand 02/2021 - PDF - 161 KB",
        EffectaKostenundZuwendungenMenu: "Stand 02/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 02/2021 - PDF - 211 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2021 - PDF - 256 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-HM-01": {
        ZeichnungsscheinMenu: "Stand 02/2021 - PDF - 573 KB",
        RisikenMenu: "Stand 02/2021 - PDF - 140 KB",
        EffectaKostenundZuwendungenMenu: "Stand 02/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 02/2021 - PDF - 209 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2021 - PDF - 257 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-TC-01": {
        ZeichnungsscheinMenu: "Stand 02/2021 - PDF - 573 KB",
        RisikenMenu: "Stand 02/2021 - PDF - 139 KB",
        EffectaKostenundZuwendungenMenu: "Stand 02/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 02/2021 - PDF - 210 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2021 - PDF - 254 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-CH-01": {
        ZeichnungsscheinMenu: "Stand 03/2021 - PDF - 573 KB",
        RisikenMenu: "Stand 03/2021 - PDF - 139 KB",
        EffectaKostenundZuwendungenMenu: "Stand 03/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 03/2021 - PDF - 210 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 03/2021 - PDF - 254 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-ML-01": {
        ZeichnungsscheinMenu: "Stand 03/2021 - PDF - 519 KB",
        RisikenMenu: "Stand 03/2021 - PDF - 184 KB",
        EffectaKostenundZuwendungenMenu: "Stand 03/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 03/2021 - PDF - 212 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 03/2021 - PDF - 260 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-KH-01": {
        ZeichnungsscheinMenu: "Stand 04/2021 - PDF - 525 KB",
        RisikenMenu: "Stand 04/2021 - PDF - 183 KB",
        EffectaKostenundZuwendungenMenu: "Stand 04/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 04/2021 - PDF - 102 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 04/2021 - PDF - 232 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-AW-02": {
        ZeichnungsscheinMenu: "Stand 06/2021 - PDF - 601 KB",
        RisikenMenu: "Stand 06/2021 - PDF - 164 KB",
        EffectaKostenundZuwendungenMenu: "Stand 06/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 06/2021 - PDF - 213 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 06/2021 - PDF - 305 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-AW-03": {
        ZeichnungsscheinMenu: "Stand 07/2021 - PDF - 604 KB",
        RisikenMenu: "Stand 07/2021 - PDF - 165 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2021 - PDF - 213 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2021 - PDF - 282 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-AK-01": {
        ZeichnungsscheinMenu: "Stand 07/2021 - PDF - 583 KB",
        RisikenMenu: "Stand 07/2021 - PDF - 142 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2021 - PDF - 214 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2021 - PDF - 282 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-GU-02": {
        ZeichnungsscheinMenu: "Stand 08/2021 - PDF - 583 KB",
        RisikenMenu: "Stand 08/2021 - PDF - 165 KB",
        EffectaKostenundZuwendungenMenu: "Stand 08/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 08/2021 - PDF - 215 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 08/2021 - PDF - 281 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-JK-01": {
        ZeichnungsscheinMenu: "Stand 09/2021 - PDF - 583 KB",
        RisikenMenu: "Stand 09/2021 - PDF - 165 KB",
        EffectaKostenundZuwendungenMenu: "Stand 09/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 09/2021 - PDF - 215 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 09/2021 - PDF - 281 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-AI-01": {
        ZeichnungsscheinMenu: "Stand 09/2021 - PDF - 572 KB",
        RisikenMenu: "Stand 09/2021 - PDF - 167 KB",
        EffectaKostenundZuwendungenMenu: "Stand 09/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 09/2021 - PDF - 218 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 09/2021 - PDF - 283 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-FP-01": {
        ZeichnungsscheinMenu: "Stand 06/2021 - PDF - 606 KB",
        RisikenMenu: "Stand 06/2021 - PDF - 165 KB",
        EffectaKostenundZuwendungenMenu: "Stand 06/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 06/2021 - PDF - 218 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 06/2021 - PDF - 279 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-FY-01": {
        ZeichnungsscheinMenu: "Stand 07/2021 - PDF - 608 KB",
        RisikenMenu: "Stand 07/2021 - PDF - 168 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2021 - PDF - 218 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2021 - PDF - 272 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-FG-01": {
        ZeichnungsscheinMenu: "Stand 07/2021 - PDF - 607 KB",
        RisikenMenu: "Stand 07/2021 - PDF - 168 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2021 - PDF - 219 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2021 - PDF - 278 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-WE-01": {
        ZeichnungsscheinMenu: "Stand 08/2021 - PDF - 607 KB",
        RisikenMenu: "Stand 08/2021 - PDF - 168 KB",
        EffectaKostenundZuwendungenMenu: "Stand 08/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 08/2021 - PDF - 219 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 08/2021 - PDF - 278 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-FB-01": {
        ZeichnungsscheinMenu: "Stand 09/2021 - PDF - 599 KB",
        RisikenMenu: "Stand 09/2021 - PDF - 170 KB",
        EffectaKostenundZuwendungenMenu: "Stand 09/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 09/2021 - PDF - 217 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 09/2021 - PDF - 281 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-FG-02": {
        ZeichnungsscheinMenu: "Stand 09/2021 - PDF - 572 KB",
        RisikenMenu: "Stand 09/2021 - PDF - 170 KB",
        EffectaKostenundZuwendungenMenu: "Stand 09/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 09/2021 - PDF - 224 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 09/2021 - PDF - 283 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-RC-01": {
        ZeichnungsscheinMenu: "Stand 03/2021 - PDF - 589 KB",
        RisikenMenu: "Stand 03/2021 - PDF - 143 KB",
        EffectaKostenundZuwendungenMenu: "Stand 03/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 03/2021 - PDF - 211 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 03/2021 - PDF - 258 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-CL-01": {
        ZeichnungsscheinMenu: "Stand 03/2021 - PDF - 607 KB",
        RisikenMenu: "Stand 03/2021 - PDF - 138 KB",
        EffectaKostenundZuwendungenMenu: "Stand 03/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 03/2021 - PDF - 212 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 03/2021 - PDF - 252 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-LP-01": {
        ZeichnungsscheinMenu: "Stand 03/2021 - PDF - 542 KB",
        RisikenMenu: "Stand 03/2021 - PDF - 383 KB",
        EffectaKostenundZuwendungenMenu: "Stand 03/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 03/2021 - PDF - 211 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 03/2021 - PDF - 252 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-OO-01": {
        ZeichnungsscheinMenu: "Stand 05/2021 - PDF - 621 KB",
        RisikenMenu: "Stand 05/2021 - PDF - 161 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 05/2021 - PDF - 213 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 05/2021 - PDF - 252 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-SM-01": {
        ZeichnungsscheinMenu: "Stand 06/2021 - PDF - 620 KB",
        RisikenMenu: "Stand 06/2021 - PDF - 171 KB",
        EffectaKostenundZuwendungenMenu: "Stand 06/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 06/2021 - PDF - 213 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 06/2021 - PDF - 253 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-CF-01": {
        ZeichnungsscheinMenu: "Stand 07/2021 - PDF - 608 KB",
        RisikenMenu: "Stand 07/2021 - PDF - 173 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2021 - PDF - 213 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2021 - PDF - 253 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-CC-01": {
        ZeichnungsscheinMenu: "Stand 08/2021 - PDF - 608 KB",
        RisikenMenu: "Stand 08/2021 - PDF - 173 KB",
        EffectaKostenundZuwendungenMenu: "Stand 08/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 08/2021 - PDF - 213 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 08/2021 - PDF - 253 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-PG-01": {
        ZeichnungsscheinMenu: "Stand 07/2021 - PDF - 621 KB",
        RisikenMenu: "Stand 07/2021 - PDF - 172 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2021 - PDF - 215 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2021 - PDF - 256 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-PH-01": {
        ZeichnungsscheinMenu: "Stand 08/2021 - PDF - 602 KB",
        RisikenMenu: "Stand 08/2021 - PDF - 172 KB",
        EffectaKostenundZuwendungenMenu: "Stand 08/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 08/2021 - PDF - 218 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 08/2021 - PDF - 261 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-BG-01": {
        ZeichnungsscheinMenu: "Stand 09/2021 - PDF - 583 KB",
        RisikenMenu: "Stand 09/2021 - PDF - 165 KB",
        EffectaKostenundZuwendungenMenu: "Stand 09/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 09/2021 - PDF - 215 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 09/2021 - PDF - 281 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-LR-01": {
        ZeichnungsscheinMenu: "Stand 09/2021 - PDF - 577 KB",
        RisikenMenu: "Stand 09/2021 - PDF - 170 KB",
        EffectaKostenundZuwendungenMenu: "Stand 09/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 09/2021 - PDF - 220 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 09/2021 - PDF - 259 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-FRA-02": {
        ZeichnungsscheinMenu: "Stand 10/2021 - PDF - 602 KB",
        RisikenMenu: "Stand 10/2021 - PDF - 171 KB",
        EffectaKostenundZuwendungenMenu: "Stand 10/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 10/2021 - PDF - 225 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 10/2021 - PDF - 262 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-FB-02": {
        ZeichnungsscheinMenu: "Stand 10/2021 - PDF - 557 KB",
        RisikenMenu: "Stand 10/2021 - PDF - 169 KB",
        EffectaKostenundZuwendungenMenu: "Stand 10/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 10/2021 - PDF - 226 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 10/2021 - PDF - 282 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-GC-01": {
        ZeichnungsscheinMenu: "Stand 10/2021 - PDF - 566 KB",
        RisikenMenu: "Stand 10/2021 - PDF - 171 KB",
        EffectaKostenundZuwendungenMenu: "Stand 10/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 10/2021 - PDF - 219 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 10/2021 - PDF - 258 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-AI-02": {
        ZeichnungsscheinMenu: "Stand 10/2021 - PDF - 573 KB",
        RisikenMenu: "Stand 10/2021 - PDF - 169 KB",
        EffectaKostenundZuwendungenMenu: "Stand 10/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 10/2021 - PDF - 218 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 10/2021 - PDF - 284 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-CC-02": {
        ZeichnungsscheinMenu: "Stand 10/2021 - PDF - 509 KB",
        RisikenMenu: "Stand 10/2021 - PDF - 149 KB",
        EffectaKostenundZuwendungenMenu: "Stand 10/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 10/2021 - PDF - 203 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 10/2021 - PDF - 256 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-TD-01": {
        ZeichnungsscheinMenu: "Stand 11/2021 - PDF - 580 KB",
        RisikenMenu: "Stand 11/2021 - PDF - 149 KB",
        EffectaKostenundZuwendungenMenu: "Stand 11/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 11/2021 - PDF - 223 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 11/2021 - PDF - 295 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-JK-02": {
        ZeichnungsscheinMenu: "Stand 11/2021 - PDF - 570 KB",
        RisikenMenu: "Stand 11/2021 - PDF - 142 KB",
        EffectaKostenundZuwendungenMenu: "Stand 11/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 11/2021 - PDF - 218 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 11/2021 - PDF - 287 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "CD-PP-DE-HH-03": {
        ZeichnungsscheinMenu: "Stand 11/2021 - PDF - 513 KB",
        RisikenMenu: "Stand 11/2021 - PDF - 138 KB",
        EffectaKostenundZuwendungenMenu: "Stand 11/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 11/2021 - PDF - 206 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 11/2021 - PDF - 357 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-HH-08": {
        ZeichnungsscheinMenu: "Stand 11/2021 - PDF - 513 KB",
        RisikenMenu: "Stand 11/2021 - PDF - 138 KB",
        EffectaKostenundZuwendungenMenu: "Stand 11/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 11/2021 - PDF - 208 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 11/2021 - PDF - 419 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-KA-01": {
        ZeichnungsscheinMenu: "Stand 11/2021 - PDF - 550 KB",
        RisikenMenu: "Stand 11/2021 - PDF - 147 KB",
        EffectaKostenundZuwendungenMenu: "Stand 11/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 11/2021 - PDF - 218 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 11/2021 - PDF - 287 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-FY-02": {
        ZeichnungsscheinMenu: "Stand 11/2021 - PDF - 551 KB",
        RisikenMenu: "Stand 11/2021 - PDF - 171 KB",
        EffectaKostenundZuwendungenMenu: "Stand 11/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 11/2021 - PDF - 225 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 11/2021 - PDF - 238 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-CC-03": {
        ZeichnungsscheinMenu: "Stand 11/2021 - PDF - 511 KB",
        RisikenMenu: "Stand 11/2021 - PDF - 148 KB",
        EffectaKostenundZuwendungenMenu: "Stand 11/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 11/2021 - PDF - 214 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 11/2021 - PDF - 257 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-PM-01": {
        ZeichnungsscheinMenu: "Stand 12/2021 - PDF - 552 KB",
        RisikenMenu: "Stand 12/2021 - PDF - 168 KB",
        EffectaKostenundZuwendungenMenu: "Stand 12/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 12/2021 - PDF - 219 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 12/2021 - PDF - 286 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-FP-02": {
        ZeichnungsscheinMenu: "Stand 12/2021 - PDF - 552 KB",
        RisikenMenu: "Stand 12/2021 - PDF - 171 KB",
        EffectaKostenundZuwendungenMenu: "Stand 12/2021 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 12/2021 - PDF - 225 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 12/2021 - PDF - 285 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 02/2021 - PDF - 98 KB",
    },
    "DE-RI-01": {
        ZeichnungsscheinMenu: "Stand 01/2022 - PDF - 554 KB",
        RisikenMenu: "Stand 01/2022 - PDF - 169 KB",
        EffectaKostenundZuwendungenMenu: "Stand 01/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 01/2022 - PDF - 218 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 01/2022 - PDF - 287 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 12/2021 - PDF - 329 KB",
    },
    "DE-HH-09": {
        ZeichnungsscheinMenu: "Stand 01/2022 - PDF - 533 KB",
        RisikenMenu: "Stand 01/2022 - PDF - 135 KB",
        EffectaKostenundZuwendungenMenu: "Stand 01/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 01/2022 - PDF - 220 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 01/2022 - PDF - 417 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 12/2021 - PDF - 329 KB",
    },
    "DE-CM-01": {
        ZeichnungsscheinMenu: "Stand 01/2022 - PDF - 527 KB",
        RisikenMenu: "Stand 01/2022 - PDF - 138 KB",
        EffectaKostenundZuwendungenMenu: "Stand 01/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 01/2022 - PDF - 224 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 01/2022 - PDF - 422 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 12/2021 - PDF - 329 KB",
    },
    "DE-FG-03": {
        ZeichnungsscheinMenu: "Stand 01/2022 - PDF - 660 KB",
        RisikenMenu: "Stand 01/2022 - PDF - 171 KB",
        EffectaKostenundZuwendungenMenu: "Stand 01/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 01/2022 - PDF - 225 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 01/2022 - PDF - 285 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-CC-04": {
        ZeichnungsscheinMenu: "Stand 01/2022 - PDF - 691 KB",
        RisikenMenu: "Stand 01/2022 - PDF - 169 KB",
        EffectaKostenundZuwendungenMenu: "Stand 01/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 01/2022 - PDF - 230 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 01/2022 - PDF - 283 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-FP-03": {
        ZeichnungsscheinMenu: "Stand 02/2022 - PDF - 660 KB",
        RisikenMenu: "Stand 02/2022 - PDF - 171 KB",
        EffectaKostenundZuwendungenMenu: "Stand 02/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 02/2022 - PDF - 225 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2022 - PDF - 285 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-KA-02": {
        ZeichnungsscheinMenu: "Stand 02/2022 - PDF - 695 KB",
        RisikenMenu: "Stand 02/2022 - PDF - 167 KB",
        EffectaKostenundZuwendungenMenu: "Stand 02/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 02/2022 - PDF - 210 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2022 - PDF - 281 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-PP-01": {
        ZeichnungsscheinMenu: "Stand 02/2022 - PDF - 670 KB",
        RisikenMenu: "Stand 02/2022 - PDF - 168 KB",
        EffectaKostenundZuwendungenMenu: "Stand 02/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 02/2022 - PDF - 201 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2022 - PDF - 255 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-K-02": {
        ZeichnungsscheinMenu: "Stand 02/2022 - PDF - 640 KB",
        RisikenMenu: "Stand 02/2022 - PDF - 157 KB",
        EffectaKostenundZuwendungenMenu: "Stand 02/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 02/2022 - PDF - 215 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2022 - PDF - 419 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-FO-01": {
        ZeichnungsscheinMenu: "Stand 02/2022 - PDF - 663 KB",
        RisikenMenu: "Stand 02/2022 - PDF - 169 KB",
        EffectaKostenundZuwendungenMenu: "Stand 02/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 02/2022 - PDF - 207 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2022 - PDF - 281 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-CC-05": {
        ZeichnungsscheinMenu: "Stand 02/2022 - PDF - 581 KB",
        RisikenMenu: "Stand 02/2022 - PDF - 148 KB",
        EffectaKostenundZuwendungenMenu: "Stand 02/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 02/2022 - PDF - 211 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2022 - PDF - 254 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "SACHWERT-01": {
        ZeichnungsscheinMenu: "Stand 02/2022 - PDF - 441 KB",
        RisikenMenu: "Stand 02/2022 - PDF - 84 KB",
        EffectaKostenundZuwendungenMenu: "Stand 02/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 02/2022 - PDF - 123 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2022 - PDF - 422 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "ASSETTA-01": {
        ZeichnungsscheinMenu: "Stand 03/2022 - PDF - 468 KB",
        RisikenMenu: "Stand 03/2022 - PDF - 188 KB",
        EffectaKostenundZuwendungenMenu: "Stand 03/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 03/2022 - PDF - 197 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 03/2022 - PDF - 250 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-PR-01": {
        ZeichnungsscheinMenu: "Stand 03/2022 - PDF - 669 KB",
        RisikenMenu: "Stand 03/2022 - PDF - 167 KB",
        EffectaKostenundZuwendungenMenu: "Stand 03/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 03/2022 - PDF - 199 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 03/2022 - PDF - 254 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-AP-01": {
        ZeichnungsscheinMenu: "Stand 03/2022 - PDF - 665 KB",
        RisikenMenu: "Stand 03/2022 - PDF - 164 KB",
        EffectaKostenundZuwendungenMenu: "Stand 03/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 03/2022 - PDF - 203 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 03/2022 - PDF - 256 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-FP-04": {
        ZeichnungsscheinMenu: "Stand 03/2022 - PDF - 665 KB",
        RisikenMenu: "Stand 03/2022 - PDF - 164 KB",
        EffectaKostenundZuwendungenMenu: "Stand 03/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 03/2022 - PDF - 208 KB",
        VerwahrungAGBMenu: "Stand 04/2020 - PDF - 117 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 03/2022 - PDF - 261 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-RC-02": {
        ZeichnungsscheinMenu: "Stand 04/2022 - PDF - 669 KB",
        RisikenMenu: "Stand 04/2022 - PDF - 168 KB",
        EffectaKostenundZuwendungenMenu: "Stand 04/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 04/2022 - PDF - 201 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 04/2022 - PDF - 253 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-DH-01": {
        ZeichnungsscheinMenu: "Stand 04/2022 - PDF - 661 KB",
        RisikenMenu: "Stand 04/2022 - PDF - 167 KB",
        EffectaKostenundZuwendungenMenu: "Stand 04/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 04/2022 - PDF - 201 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 04/2022 - PDF - 289 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-FG-04": {
        ZeichnungsscheinMenu: "Stand 04/2022 - PDF - 669 KB",
        RisikenMenu: "Stand 04/2022 - PDF - 168 KB",
        EffectaKostenundZuwendungenMenu: "Stand 04/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 04/2022 - PDF - 201 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 04/2022 - PDF - 253 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-CC-06": {
        ZeichnungsscheinMenu: "Stand 04/2022 - PDF - 577 KB",
        RisikenMenu: "Stand 04/2022 - PDF - 149 KB",
        EffectaKostenundZuwendungenMenu: "Stand 04/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 04/2022 - PDF - 209 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 04/2022 - PDF - 253 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-BK-01": {
        ZeichnungsscheinMenu: "Stand 04/2022 - PDF - 665 KB",
        RisikenMenu: "Stand 04/2022 - PDF - 149 KB",
        EffectaKostenundZuwendungenMenu: "Stand 04/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 04/2022 - PDF - 201 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 04/2022 - PDF - 245 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-FP-05": {
        ZeichnungsscheinMenu: "Stand 05/2022 - PDF - 653 KB",
        RisikenMenu: "Stand 05/2022 - PDF - 170 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 05/2022 - PDF - 201 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 05/2022 - PDF - 284 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-ST-01": {
        ZeichnungsscheinMenu: "Stand 05/2022 - PDF - 660 KB",
        RisikenMenu: "Stand 05/2022 - PDF - 171 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 05/2022 - PDF - 201 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 05/2022 - PDF - 252 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-S-01": {
        ZeichnungsscheinMenu: "Stand 05/2022 - PDF - 640 KB",
        RisikenMenu: "Stand 05/2022 - PDF - 142 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 05/2022 - PDF - 201 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 05/2022 - PDF - 224 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-DE-S-01": {
        ZeichnungsscheinMenu: "Stand 05/2022 - PDF - 601 KB",
        RisikenMenu: "Stand 05/2022 - PDF - 141 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 05/2022 - PDF - 201 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 05/2022 - PDF - 222 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-AW-04": {
        ZeichnungsscheinMenu: "Stand 05/2022 - PDF - 644 KB",
        RisikenMenu: "Stand 05/2022 - PDF - 167 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 05/2022 - PDF - 200 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 05/2022 - PDF - 262 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-AE-01": {
        ZeichnungsscheinMenu: "Stand 06/2022 - PDF - 679 KB",
        RisikenMenu: "Stand 06/2022 - PDF - 170 KB",
        EffectaKostenundZuwendungenMenu: "Stand 06/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 06/2022 - PDF - 201 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 06/2022 - PDF - 255 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-BA-01": {
        ZeichnungsscheinMenu: "Stand 06/2022 - PDF - 669 KB",
        RisikenMenu: "Stand 06/2022 - PDF - 170 KB",
        EffectaKostenundZuwendungenMenu: "Stand 06/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 06/2022 - PDF - 199 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 06/2022 - PDF - 260 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "WATCHVEST-01": {
        ZeichnungsscheinMenu: "Stand 06/2022 - PDF - 800 KB",
        RisikenMenu: "Stand 06/2022 - PDF - 170 KB",
        EffectaKostenundZuwendungenMenu: "Stand 06/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 06/2022 - PDF - 209 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 06/2022 - PDF - 243 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-WD-01": {
        ZeichnungsscheinMenu: "Stand 06/2022 - PDF - 665 KB",
        RisikenMenu: "Stand 06/2022 - PDF - 171 KB",
        EffectaKostenundZuwendungenMenu: "Stand 06/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 06/2022 - PDF - 202 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 06/2022 - PDF - 280 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-RL-01": {
        ZeichnungsscheinMenu: "Stand 07/2022 - PDF - 655 KB",
        RisikenMenu: "Stand 07/2022 - PDF - 169 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2022 - PDF - 199 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2022 - PDF - 260 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-CC-07": {
        ZeichnungsscheinMenu: "Stand 07/2022 - PDF - 577 KB",
        RisikenMenu: "Stand 07/2022 - PDF - 148 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2022 - PDF - 210 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2022 - PDF - 253 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-CC-08": {
        ZeichnungsscheinMenu: "Stand 07/2022 - PDF - 577 KB",
        RisikenMenu: "Stand 07/2022 - PDF - 148 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2022 - PDF - 210 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2022 - PDF - 255 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-CC-09": {
        ZeichnungsscheinMenu: "Stand 09/2022 - PDF - 633 KB",
        RisikenMenu: "Stand 09/2022 - PDF - 149 KB",
        EffectaKostenundZuwendungenMenu: "Stand 09/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 09/2022 - PDF - 214 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 09/2022 - PDF - 255 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-CC-10": {
        ZeichnungsscheinMenu: "Stand 02/2023 - PDF - 581 KB",
        RisikenMenu: "Stand 02/2023 - PDF - 148 KB",
        EffectaKostenundZuwendungenMenu: "Stand 02/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 02/2023 - PDF - 184 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2023 - PDF - 255 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-CL-02": {
        ZeichnungsscheinMenu: "Stand 07/2022 - PDF - 678 KB",
        RisikenMenu: "Stand 07/2022 - PDF - 171 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2022 - PDF - 200 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2022 - PDF - 254 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-PD-01": {
        ZeichnungsscheinMenu: "Stand 07/2022 - PDF - 669 KB",
        RisikenMenu: "Stand 07/2022 - PDF - 168 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2022 - PDF - 200 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2022 - PDF - 268 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "WIN-01": {
        ZeichnungsscheinMenu: "Stand 07/2022 - PDF - 322 KB",
        RisikenMenu: "Stand 07/2022 - PDF - 110 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 01/2023 - PDF - 129 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2022 - PDF - 188 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "WIN-02": {
        ZeichnungsscheinMenu: "Stand 07/2022 - PDF - 322 KB",
        RisikenMenu: "Stand 07/2022 - PDF - 110 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 01/2023 - PDF - 128 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2022 - PDF - 188 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-FO-02": {
        ZeichnungsscheinMenu: "Stand 07/2022 - PDF - 666 KB",
        RisikenMenu: "Stand 07/2022 - PDF - 164 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2022 - PDF - 202 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2022 - PDF - 283 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-DP-01": {
        ZeichnungsscheinMenu: "Stand 07/2022 - PDF - 678 KB",
        RisikenMenu: "Stand 07/2022 - PDF - 192 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2022 - PDF - 203 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2022 - PDF - 257 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "WATCHVEST-02": {
        ZeichnungsscheinMenu: "Stand 07/2022 - PDF - 576 KB",
        RisikenMenu: "Stand 07/2022 - PDF - 254 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2022 - PDF - 204 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2022 - PDF - 336 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-FRA-03": {
        ZeichnungsscheinMenu: "Stand 07/2022 - PDF - 607 KB",
        RisikenMenu: "Stand 07/2022 - PDF - 142 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2022 - PDF - 203 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2022 - PDF - 225 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-DE-FRA-01": {
        ZeichnungsscheinMenu: "Stand 07/2022 - PDF - 611 KB",
        RisikenMenu: "Stand 07/2022 - PDF - 145 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2022 - PDF - 206 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2022 - PDF - 255 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-SE-01": {
        ZeichnungsscheinMenu: "Stand 07/2022 - PDF - 626 KB",
        RisikenMenu: "Stand 07/2022 - PDF - 145 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2022 - PDF - 216 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2022 - PDF - 253 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "WIN-03": {
        ZeichnungsscheinMenu: "Stand 07/2022 - PDF - 311 KB",
        RisikenMenu: "Stand 07/2022 - PDF - 103 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 01/2023 - PDF - 110 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2022 - PDF - 134 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-FP-06": {
        ZeichnungsscheinMenu: "Stand 08/2022 - PDF - 667 KB",
        RisikenMenu: "Stand 08/2022 - PDF - 151 KB",
        EffectaKostenundZuwendungenMenu: "Stand 08/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 08/2022 - PDF - 202 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 08/2022 - PDF - 285 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "SACHWERT-02": {
        ZeichnungsscheinMenu: "Stand 08/2022 - PDF - 307 KB",
        RisikenMenu: "Stand 08/2022 - PDF - 84 KB",
        EffectaKostenundZuwendungenMenu: "Stand 08/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 08/2022 - PDF - 1200 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 08/2022 - PDF - 897 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "SACHWERT-03": {
        ZeichnungsscheinMenu: "Stand 08/2022 - PDF - 308 KB",
        RisikenMenu: "Stand 08/2022 - PDF - 84 KB",
        EffectaKostenundZuwendungenMenu: "Stand 08/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 08/2022 - PDF - 1200 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 08/2022 - PDF - 898 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "WATCHVEST-03": {
        ZeichnungsscheinMenu: "Stand 08/2022 - PDF - 576 KB",
        RisikenMenu: "Stand 08/2022 - PDF - 254 KB",
        EffectaKostenundZuwendungenMenu: "Stand 08/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 08/2022 - PDF - 204 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 08/2022 - PDF - 336 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "WA-PP-01": {
        ZeichnungsscheinMenu: "Stand 09/2022 - PDF - 581 KB",
        RisikenMenu: "Stand 09/2022 - PDF - 169 KB",
        EffectaKostenundZuwendungenMenu: "Stand 09/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 09/2022 - PDF - 230 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 09/2022 - PDF - 253 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DI-FP-01": {
        ZeichnungsscheinMenu: "Stand 08/2022 - PDF - 666 KB",
        RisikenMenu: "Stand 08/2022 - PDF - 172 KB",
        EffectaKostenundZuwendungenMenu: "Stand 08/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 08/2022 - PDF - 201 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 08/2022 - PDF - 279 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "FA-BA-01": {
        ZeichnungsscheinMenu: "Stand 09/2022 - PDF - 667 KB",
        RisikenMenu: "Stand 09/2022 - PDF - 169 KB",
        EffectaKostenundZuwendungenMenu: "Stand 09/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 09/2022 - PDF - 200 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 09/2022 - PDF - 262 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "FA-JS-01": {
        ZeichnungsscheinMenu: "Stand 09/2022 - PDF - 662 KB",
        RisikenMenu: "Stand 09/2022 - PDF - 169 KB",
        EffectaKostenundZuwendungenMenu: "Stand 09/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 09/2022 - PDF - 199 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 09/2022 - PDF - 262 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "PE-CV-01": {
        ZeichnungsscheinMenu: "Stand 09/2022 - PDF - 582 KB",
        RisikenMenu: "Stand 09/2022 - PDF - 163 KB",
        EffectaKostenundZuwendungenMenu: "Stand 09/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 09/2022 - PDF - 199 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 09/2022 - PDF - 123 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "PE-LB-01": {
        ZeichnungsscheinMenu: "Stand 09/2022 - PDF - 562 KB",
        RisikenMenu: "Stand 09/2022 - PDF - 139 KB",
        EffectaKostenundZuwendungenMenu: "Stand 09/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 09/2022 - PDF - 187 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 09/2022 - PDF - 148 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-PE-LB-01": {
        ZeichnungsscheinMenu: "Stand 09/2022 - PDF - 562 KB",
        RisikenMenu: "Stand 09/2022 - PDF - 139 KB",
        EffectaKostenundZuwendungenMenu: "Stand 09/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 09/2022 - PDF - 188 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 09/2022 - PDF - 148 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-PE-LB-02": {
        ZeichnungsscheinMenu: "Stand 09/2022 - PDF - 563 KB",
        RisikenMenu: "Stand 09/2022 - PDF - 139 KB",
        EffectaKostenundZuwendungenMenu: "Stand 09/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 09/2022 - PDF - 188 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 09/2022 - PDF - 148 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "WA-RX-01": {
        ZeichnungsscheinMenu: "Stand 10/2022 - PDF - 663 KB",
        RisikenMenu: "Stand 10/2022 - PDF - 192 KB",
        EffectaKostenundZuwendungenMenu: "Stand 10/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 10/2022 - PDF - 209 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 10/2022 - PDF - 255 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "FA-EH-01": {
        ZeichnungsscheinMenu: "Stand 09/2022 - PDF - 640 KB",
        RisikenMenu: "Stand 09/2022 - PDF - 167 KB",
        EffectaKostenundZuwendungenMenu: "Stand 09/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 09/2022 - PDF - 210 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 09/2022 - PDF - 268 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "FW-BS-01": {
        ZeichnungsscheinMenu: "Stand 10/2022 - PDF - 652 KB",
        RisikenMenu: "Stand 10/2022 - PDF - 149 KB",
        EffectaKostenundZuwendungenMenu: "Stand 10/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 10/2022 - PDF - 200 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 10/2022 - PDF - 256 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "FA-GU-01": {
        ZeichnungsscheinMenu: "Stand 10/2022 - PDF - 641 KB",
        RisikenMenu: "Stand 10/2022 - PDF - 168 KB",
        EffectaKostenundZuwendungenMenu: "Stand 10/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 10/2022 - PDF - 199 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 10/2022 - PDF - 262 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DI-FY-01": {
        ZeichnungsscheinMenu: "Stand 11/2022 - PDF - 641 KB",
        RisikenMenu: "Stand 11/2022 - PDF - 168 KB",
        EffectaKostenundZuwendungenMenu: "Stand 11/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 11/2022 - PDF - 199 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 11/2022 - PDF - 262 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-DE-MA-01": {
        ZeichnungsscheinMenu: "Stand 11/2022 - PDF - 650 KB",
        RisikenMenu: "Stand 11/2022 - PDF - 137 KB",
        EffectaKostenundZuwendungenMenu: "Stand 11/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 11/2022 - PDF - 218 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 11/2022 - PDF - 140 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-DE-MA-02": {
        ZeichnungsscheinMenu: "Stand 11/2022 - PDF - 651 KB",
        RisikenMenu: "Stand 11/2022 - PDF - 137 KB",
        EffectaKostenundZuwendungenMenu: "Stand 11/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 11/2022 - PDF - 217 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 11/2022 - PDF - 141 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "WA-PP-02": {
        ZeichnungsscheinMenu: "Stand 11/2022 - PDF - 595 KB",
        RisikenMenu: "Stand 11/2022 - PDF - 170 KB",
        EffectaKostenundZuwendungenMenu: "Stand 11/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 11/2022 - PDF - 208 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 11/2022 - PDF - 257 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-WA-PP-02": {
        ZeichnungsscheinMenu: "Stand 11/2022 - PDF - 610 KB",
        RisikenMenu: "Stand 11/2022 - PDF - 191 KB",
        EffectaKostenundZuwendungenMenu: "Stand 11/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 11/2022 - PDF - 208 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 11/2022 - PDF - 258 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "WIN-04": {
        ZeichnungsscheinMenu: "Stand 11/2022 - PDF - 342 KB",
        RisikenMenu: "Stand 11/2022 - PDF - 129 KB",
        EffectaKostenundZuwendungenMenu: "Stand 11/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 01/2023 - PDF - 130 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 11/2022 - PDF - 141 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "WIN-05": {
        ZeichnungsscheinMenu: "Stand 11/2022 - PDF - 341 KB",
        RisikenMenu: "Stand 11/2022 - PDF - 130 KB",
        EffectaKostenundZuwendungenMenu: "Stand 11/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 01/2023 - PDF - 130 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 11/2022 - PDF - 141 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DI-FP-02": {
        ZeichnungsscheinMenu: "Stand 12/2022 - PDF - 645 KB",
        RisikenMenu: "Stand 12/2022 - PDF - 150 KB",
        EffectaKostenundZuwendungenMenu: "Stand 12/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 12/2022 - PDF - 203 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 12/2022 - PDF - 281 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "SI-JV-01": {
        ZeichnungsscheinMenu: "Stand 12/2022 - PDF - 581 KB",
        RisikenMenu: "Stand 12/2022 - PDF - 148 KB",
        EffectaKostenundZuwendungenMenu: "Stand 12/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 12/2022 - PDF - 211 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 12/2022 - PDF - 270 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-SI-JV-01": {
        ZeichnungsscheinMenu: "Stand 12/2022 - PDF - 582 KB",
        RisikenMenu: "Stand 12/2022 - PDF - 149 KB",
        EffectaKostenundZuwendungenMenu: "Stand 12/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 12/2022 - PDF - 212 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 12/2022 - PDF - 271 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "WA-PP-03": {
        ZeichnungsscheinMenu: "Stand 12/2022 - PDF - 655 KB",
        RisikenMenu: "Stand 12/2022 - PDF - 183 KB",
        EffectaKostenundZuwendungenMenu: "Stand 12/2022 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 12/2022 - PDF - 210 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 12/2022 - PDF - 255 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "FW-BP-01": {
        ZeichnungsscheinMenu: "Stand 01/2023 - PDF - 555 KB",
        RisikenMenu: "Stand 01/2023 - PDF - 190 KB",
        EffectaKostenundZuwendungenMenu: "Stand 01/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 01/2023 - PDF - 126 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 01/2023 - PDF - 232 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "WA-PP-04": {
        ZeichnungsscheinMenu: "Stand 01/2023 - PDF - 603 KB",
        RisikenMenu: "Stand 01/2023 - PDF - 184 KB",
        EffectaKostenundZuwendungenMenu: "Stand 01/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 01/2023 - PDF - 184 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 01/2023 - PDF - 252 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "FA-BA-02": {
        ZeichnungsscheinMenu: "Stand 01/2023 - PDF - 675 KB",
        RisikenMenu: "Stand 01/2023 - PDF - 169 KB",
        EffectaKostenundZuwendungenMenu: "Stand 01/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 01/2023 - PDF - 189 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 01/2023 - PDF - 128 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-FA-BA-02": {
        ZeichnungsscheinMenu: "Stand 01/2023 - PDF - 678 KB",
        RisikenMenu: "Stand 01/2023 - PDF - 169 KB",
        EffectaKostenundZuwendungenMenu: "Stand 01/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 01/2023 - PDF - 188 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 01/2023 - PDF - 128 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "WIN-06": {
        ZeichnungsscheinMenu: "Stand 01/2023 - PDF - 341 KB",
        RisikenMenu: "Stand 01/2023 - PDF - 130 KB",
        EffectaKostenundZuwendungenMenu: "Stand 01/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 01/2023 - PDF - 130 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 01/2023 - PDF - 141 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "WA-PP-05": {
        ZeichnungsscheinMenu: "Stand 01/2023 - PDF - 603 KB",
        RisikenMenu: "Stand 01/2023 - PDF - 184 KB",
        EffectaKostenundZuwendungenMenu: "Stand 01/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 01/2023 - PDF - 187 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 01/2023 - PDF - 253 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DI-FP-03": {
        ZeichnungsscheinMenu: "Stand 01/2023 - PDF - 556 KB",
        RisikenMenu: "Stand 01/2023 - PDF - 148 KB",
        EffectaKostenundZuwendungenMenu: "Stand 01/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 02/2023 - PDF - 124 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 01/2023 - PDF - 287 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-DE-MA-03": {
        ZeichnungsscheinMenu: "Stand 02/2023 - PDF - 601 KB",
        RisikenMenu: "Stand 02/2023 - PDF - 135 KB",
        EffectaKostenundZuwendungenMenu: "Stand 02/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 02/2023 - PDF - 194 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2023 - PDF - 142 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "SI-DP-01": {
        ZeichnungsscheinMenu: "Stand 02/2023 - PDF - 632 KB",
        RisikenMenu: "Stand 02/2023 - PDF - 148 KB",
        EffectaKostenundZuwendungenMenu: "Stand 02/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 02/2023 - PDF - 205 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2023 - PDF - 270 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-SI-DP-01": {
        ZeichnungsscheinMenu: "Stand 02/2023 - PDF - 631 KB",
        RisikenMenu: "Stand 02/2023 - PDF - 145 KB",
        EffectaKostenundZuwendungenMenu: "Stand 02/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 02/2023 - PDF - 235 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2023 - PDF - 320 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-HH-10": {
        ZeichnungsscheinMenu: "Stand 02/2023 - PDF - 687 KB",
        RisikenMenu: "Stand 02/2023 - PDF - 147 KB",
        EffectaKostenundZuwendungenMenu: "Stand 02/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 02/2023 - PDF - 137 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2023 - PDF - 197 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-DE-HH-10": {
        ZeichnungsscheinMenu: "Stand 02/2023 - PDF - 682 KB",
        RisikenMenu: "Stand 02/2023 - PDF - 147 KB",
        EffectaKostenundZuwendungenMenu: "Stand 02/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 02/2023 - PDF - 141 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2023 - PDF - 202 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-DE-HH-11": {
        ZeichnungsscheinMenu: "Stand 02/2023 - PDF - 687 KB",
        RisikenMenu: "Stand 02/2023 - PDF - 145 KB",
        EffectaKostenundZuwendungenMenu: "Stand 02/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 02/2023 - PDF - 147 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2023 - PDF - 200 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "WA-RX-02": {
        ZeichnungsscheinMenu: "Stand 03/2023 - PDF - 629 KB",
        RisikenMenu: "Stand 03/2023 - PDF - 171 KB",
        EffectaKostenundZuwendungenMenu: "Stand 03/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 03/2023 - PDF - 184 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 03/2023 - PDF - 253 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "FA-IK-01": {
        ZeichnungsscheinMenu: "Stand 03/2023 - PDF - 676 KB",
        RisikenMenu: "Stand 03/2023 - PDF - 169 KB",
        EffectaKostenundZuwendungenMenu: "Stand 03/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 03/2023 - PDF - 189 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 03/2023 - PDF - 128 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-FA-IK-01": {
        ZeichnungsscheinMenu: "Stand 03/2023 - PDF - 674 KB",
        RisikenMenu: "Stand 03/2023 - PDF - 168 KB",
        EffectaKostenundZuwendungenMenu: "Stand 03/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 03/2023 - PDF - 187 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 03/2023 - PDF - 128 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "WA-PP-06": {
        ZeichnungsscheinMenu: "Stand 03/2023 - PDF - 628 KB",
        RisikenMenu: "Stand 03/2023 - PDF - 170 KB",
        EffectaKostenundZuwendungenMenu: "Stand 03/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 03/2023 - PDF - 182 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 03/2023 - PDF - 255 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-WA-PP-06": {
        ZeichnungsscheinMenu: "Stand 03/2023 - PDF - 629 KB",
        RisikenMenu: "Stand 03/2023 - PDF - 171 KB",
        EffectaKostenundZuwendungenMenu: "Stand 03/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 03/2023 - PDF - 181 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 03/2023 - PDF - 254 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "FW-TR-01": {
        ZeichnungsscheinMenu: "Stand 03/2023 - PDF - 625 KB",
        RisikenMenu: "Stand 03/2023 - PDF - 145 KB",
        EffectaKostenundZuwendungenMenu: "Stand 03/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 03/2023 - PDF - 197 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 03/2023 - PDF - 254 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-DI-RD-01": {
        ZeichnungsscheinMenu: "Stand 04/2023 - PDF - 682 KB",
        RisikenMenu: "Stand 04/2023 - PDF - 150 KB",
        EffectaKostenundZuwendungenMenu: "Stand 04/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 04/2023 - PDF - 185 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 04/2023 - PDF - 262 KB",
        EffectaAGBMenu: "Stand 09/2019 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "FAIRZINSUNG-04": {
        ZeichnungsscheinMenu: "Stand 05/2023 - PDF - 641 KB",
        RisikenMenu: "Stand 05/2023 - PDF - 126 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 05/2023 - PDF - 118 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 05/2023 - PDF - 158 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "ES-MA-02": {
        ZeichnungsscheinMenu: "Stand 05/2023 - PDF - 624 KB",
        RisikenMenu: "Stand 05/2023 - PDF - 140 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 05/2023 - PDF - 201 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 05/2023 - PDF - 120 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-ES-MA-03": {
        ZeichnungsscheinMenu: "Stand 05/2023 - PDF - 624 KB",
        RisikenMenu: "Stand 05/2023 - PDF - 140 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 05/2023 - PDF - 201 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 05/2023 - PDF - 120 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-ES-MA-04": {
        ZeichnungsscheinMenu: "Stand 05/2023 - PDF - 624 KB",
        RisikenMenu: "Stand 05/2023 - PDF - 140 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 05/2023 - PDF - 200 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 05/2023 - PDF - 120 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-ES-MA-05": {
        ZeichnungsscheinMenu: "Stand 05/2023 - PDF - 624 KB",
        RisikenMenu: "Stand 05/2023 - PDF - 140 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 05/2023 - PDF - 201 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 05/2023 - PDF - 118 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "WA-PP-06": {
        ZeichnungsscheinMenu: "Stand 03/2023 - PDF - 628 KB",
        RisikenMenu: "Stand 03/2023 - PDF - 170 KB",
        EffectaKostenundZuwendungenMenu: "Stand 03/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 03/2023 - PDF - 182 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 03/2023 - PDF - 255 KB",
        EffectaAGBMenu: "Stand 09/2019 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-WA-PP-06": {
        ZeichnungsscheinMenu: "Stand 03/2023 - PDF - 629 KB",
        RisikenMenu: "Stand 03/2023 - PDF - 171 KB",
        EffectaKostenundZuwendungenMenu: "Stand 03/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 03/2023 - PDF - 181 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 03/2023 - PDF - 254 KB",
        EffectaAGBMenu: "Stand 09/2019 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "FW-TR-01": {
        ZeichnungsscheinMenu: "Stand 03/2023 - PDF - 625 KB",
        RisikenMenu: "Stand 03/2023 - PDF - 145 KB",
        EffectaKostenundZuwendungenMenu: "Stand 03/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 03/2023 - PDF - 197 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 03/2023 - PDF - 254 KB",
        EffectaAGBMenu: "Stand 09/2019 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-DI-RD-01": {
        ZeichnungsscheinMenu: "Stand 04/2023 - PDF - 682 KB",
        RisikenMenu: "Stand 04/2023 - PDF - 150 KB",
        EffectaKostenundZuwendungenMenu: "Stand 04/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 04/2023 - PDF - 185 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 04/2023 - PDF - 262 KB",
        EffectaAGBMenu: "Stand 09/2019 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "FAIRZINSUNG-08": {
        ZeichnungsscheinMenu: "Stand 05/2023 - PDF - 641 KB",
        RisikenMenu: "Stand 05/2023 - PDF - 126 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 05/2023 - PDF - 118 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 05/2023 - PDF - 158 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "ES-MA-02": {
        ZeichnungsscheinMenu: "Stand 05/2023 - PDF - 624 KB",
        RisikenMenu: "Stand 05/2023 - PDF - 140 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 05/2023 - PDF - 201 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 05/2023 - PDF - 120 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-ES-MA-03": {
        ZeichnungsscheinMenu: "Stand 05/2023 - PDF - 624 KB",
        RisikenMenu: "Stand 05/2023 - PDF - 140 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 05/2023 - PDF - 201 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 05/2023 - PDF - 120 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-ES-MA-04": {
        ZeichnungsscheinMenu: "Stand 05/2023 - PDF - 624 KB",
        RisikenMenu: "Stand 05/2023 - PDF - 140 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 05/2023 - PDF - 200 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 05/2023 - PDF - 120 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-ES-MA-05": {
        ZeichnungsscheinMenu: "Stand 05/2023 - PDF - 624 KB",
        RisikenMenu: "Stand 05/2023 - PDF - 140 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 05/2023 - PDF - 201 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 05/2023 - PDF - 118 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "WA-PP-07": {
        ZeichnungsscheinMenu: "Stand 07/2023 - PDF - 580 KB",
        RisikenMenu: "Stand 05/2023 - PDF - 164 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 05/2023 - PDF - 188 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 05/2023 - PDF - 131 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "SI-DP-02": {
        ZeichnungsscheinMenu: "Stand 07/2023 - PDF - 529 KB",
        RisikenMenu: "Stand 05/2023 - PDF - 192 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 05/2023 - PDF - 210 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 05/2023 - PDF - 267 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-SI-DP-02": {
        ZeichnungsscheinMenu: "Stand 05/2023 - PDF - 529 KB",
        RisikenMenu: "Stand 05/2023 - PDF - 148 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 05/2023 - PDF - 215 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 05/2023 - PDF - 269 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-SI-DP-04": {
        ZeichnungsscheinMenu: "Stand 10/2024 - PDF - 652 KB",
        RisikenMenu: "Stand 10/2024 - PDF - 172 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 10/2024 - PDF - 198 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 10/2024 - PDF - 139 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "RE-EG-01": {
        ZeichnungsscheinMenu: "Stand 07/2023 - PDF - 437 KB",
        RisikenMenu: "Stand 05/2023 - PDF - 165 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 05/2023 - PDF - 113 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 05/2023 - PDF - 179 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-RE-EG-01": {
        ZeichnungsscheinMenu: "Stand 05/2023 - PDF - 438 KB",
        RisikenMenu: "Stand 05/2023 - PDF - 166 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 05/2023 - PDF - 114 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 05/2023 - PDF - 269 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-RE-EG-02": {
        ZeichnungsscheinMenu: "Stand 05/2023 - PDF - 439 KB",
        RisikenMenu: "Stand 05/2023 - PDF - 167 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 05/2023 - PDF - 115 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 05/2023 - PDF - 269 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "WA-RX-03": {
        ZeichnungsscheinMenu: "Stand 06/2023 - PDF - 610 KB",
        RisikenMenu: "Stand 06/2023 - PDF - 171 KB",
        EffectaKostenundZuwendungenMenu: "Stand 06/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 06/2023 - PDF - 190 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 06/2023 - PDF - 122 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-FA-SB-01": {
        ZeichnungsscheinMenu: "Stand 07/2023 - PDF - 639 KB",
        RisikenMenu: "Stand 07/2023 - PDF - 195 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2023 - PDF - 188 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2023 - PDF - 135 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "FW-JP-01": {
        ZeichnungsscheinMenu: "Stand 07/2023 - PDF - 611 KB",
        RisikenMenu: "Stand 07/2023 - PDF - 150 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2023 - PDF - 128 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2023 - PDF - 361 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-FW-JP-01": {
        ZeichnungsscheinMenu: "Stand 07/2023 - PDF - 619 KB",
        RisikenMenu: "Stand 07/2023 - PDF - 150 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2023 - PDF - 126 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2023 - PDF - 362 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "WA-PP-08": {
        ZeichnungsscheinMenu: "Stand 07/2023 - PDF - 606 KB",
        RisikenMenu: "Stand 07/2023 - PDF - 164 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2023 - PDF - 185 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2023 - PDF - 130 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-WA-PP-08": {
        ZeichnungsscheinMenu: "Stand 07/2023 - PDF - 603 KB",
        RisikenMenu: "Stand 07/2023 - PDF - 164 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2023 - PDF - 189 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2023 - PDF - 133 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "FAIRZINSUNG-03": {
        ZeichnungsscheinMenu: "Stand 05/2023 - PDF - 641 KB",
        RisikenMenu: "Stand 05/2023 - PDF - 126 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 05/2023 - PDF - 118 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 05/2023 - PDF - 158 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "FAIRZINSUNG-06": {
        ZeichnungsscheinMenu: "Stand 07/2023 - PDF - 641 KB",
        RisikenMenu: "Stand 07/2023 - PDF - 126 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2023 - PDF - 118 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2023 - PDF - 158 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "FAIRZINSUNG-07": {
        ZeichnungsscheinMenu: "Stand 07/2023 - PDF - 641 KB",
        RisikenMenu: "Stand 07/2023 - PDF - 126 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2023 - PDF - 118 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2023 - PDF - 158 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-FAIRZINSUNG-01": {
        ZeichnungsscheinMenu: "Stand 07/2023 - PDF - 641 KB",
        RisikenMenu: "Stand 07/2023 - PDF - 126 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2023 - PDF - 118 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2023 - PDF - 158 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "WA-RX-04": {
        ZeichnungsscheinMenu: "Stand 08/2023 - PDF - 584 KB",
        RisikenMenu: "Stand 08/2023 - PDF - 164 KB",
        EffectaKostenundZuwendungenMenu: "Stand 08/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 08/2023 - PDF - 189 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 08/2023 - PDF - 134 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-WA-RX-04": {
        ZeichnungsscheinMenu: "Stand 08/2023 - PDF - 586 KB",
        RisikenMenu: "Stand 08/2023 - PDF - 165 KB",
        EffectaKostenundZuwendungenMenu: "Stand 08/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 08/2023 - PDF - 191 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 08/2023 - PDF - 136 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-WA-RX-05": {
        ZeichnungsscheinMenu: "Stand 08/2023 - PDF - 582 KB",
        RisikenMenu: "Stand 08/2023 - PDF - 163 KB",
        EffectaKostenundZuwendungenMenu: "Stand 08/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 08/2023 - PDF - 193 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 08/2023 - PDF - 132 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "FA-JY-01": {
        ZeichnungsscheinMenu: "Stand 08/2023 - PDF - 543 KB",
        RisikenMenu: "Stand 08/2023 - PDF - 195 KB",
        EffectaKostenundZuwendungenMenu: "Stand 08/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 08/2023 - PDF - 124 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 08/2023 - PDF - 236 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "FW-US-01": {
        ZeichnungsscheinMenu: "Stand 09/2023 - PDF - 565 KB",
        RisikenMenu: "Stand 09/2023 - PDF - 194 KB",
        EffectaKostenundZuwendungenMenu: "Stand 09/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 09/2023 - PDF - 135 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 09/2023 - PDF - 305 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "WIN-07": {
        ZeichnungsscheinMenu: "Stand 09/2023 - PDF - 271 KB",
        RisikenMenu: "Stand 09/2023 - PDF - 145 KB",
        EffectaKostenundZuwendungenMenu: "Stand 09/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 09/2023 - PDF - 129 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 09/2023 - PDF - 225 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "SACHWERT-04": {
        ZeichnungsscheinMenu: "Stand 09/2023 - PDF - 569 KB",
        RisikenMenu: "Stand 09/2023 - PDF - 724 KB",
        EffectaKostenundZuwendungenMenu: "Stand 09/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 09/2023 - PDF - 245 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 09/2023 - PDF - 675 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DI-WD-01": {
        ZeichnungsscheinMenu: "Stand 09/2023 - PDF - 578 KB",
        RisikenMenu: "Stand 09/2023 - PDF - 179 KB",
        EffectaKostenundZuwendungenMenu: "Stand 09/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 09/2023 - PDF - 122 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 09/2023 - PDF - 283 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-DI-WD-01": {
        ZeichnungsscheinMenu: "Stand 09/2023 - PDF - 578 KB",
        RisikenMenu: "Stand 09/2023 - PDF - 180 KB",
        EffectaKostenundZuwendungenMenu: "Stand 09/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 09/2023 - PDF - 123 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 09/2023 - PDF - 282 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "WIN-08": {
        ZeichnungsscheinMenu: "Stand 10/2023 - PDF - 271 KB",
        RisikenMenu: "Stand 10/2023 - PDF - 145 KB",
        EffectaKostenundZuwendungenMenu: "Stand 10/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 10/2023 - PDF - 129 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 10/2023 - PDF - 225 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-FA-TC-01": {
        ZeichnungsscheinMenu: "Stand 10/2023 - PDF - 672 KB",
        RisikenMenu: "Stand 10/2023 - PDF - 196 KB",
        EffectaKostenundZuwendungenMenu: "Stand 10/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 10/2023 - PDF - 129 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 10/2023 - PDF - 130 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "ASSETTA-02": {
        ZeichnungsscheinMenu: "Stand 11/2023 - PDF - 572 KB",
        RisikenMenu: "Stand 11/2023 - PDF - 211 KB",
        EffectaKostenundZuwendungenMenu: "Stand 11/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 11/2023 - PDF - 140 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 11/2023 - PDF - 160 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "ASSETTA-02-01": {
        ZeichnungsscheinMenu: "Stand 11/2023 - PDF - 570 KB",
        RisikenMenu: "Stand 11/2023 - PDF - 211 KB",
        EffectaKostenundZuwendungenMenu: "Stand 11/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 11/2023 - PDF - 139 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 11/2023 - PDF - 156 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-ASSETTA-02-01": {
        ZeichnungsscheinMenu: "Stand 11/2023 - PDF - 573 KB",
        RisikenMenu: "Stand 11/2023 - PDF - 213 KB",
        EffectaKostenundZuwendungenMenu: "Stand 11/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 11/2023 - PDF - 139 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 11/2023 - PDF - 160 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-ASSETTA-02-02": {
        ZeichnungsscheinMenu: "Stand 11/2023 - PDF - 571 KB",
        RisikenMenu: "Stand 11/2023 - PDF - 211 KB",
        EffectaKostenundZuwendungenMenu: "Stand 11/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 11/2023 - PDF - 131 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 11/2023 - PDF - 161 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-ASSETTA-02-03": {
        ZeichnungsscheinMenu: "Stand 11/2023 - PDF - 570 KB",
        RisikenMenu: "Stand 11/2023 - PDF - 215 KB",
        EffectaKostenundZuwendungenMenu: "Stand 11/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 11/2023 - PDF - 135 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 11/2023 - PDF - 165 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-ASSETTA-02-04": {
        ZeichnungsscheinMenu: "Stand 11/2023 - PDF - 569 KB",
        RisikenMenu: "Stand 11/2023 - PDF - 209 KB",
        EffectaKostenundZuwendungenMenu: "Stand 11/2023 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 11/2023 - PDF - 136 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 11/2023 - PDF - 166 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "FA-EA-01": {
        ZeichnungsscheinMenu: "Stand 02/2024 - PDF - 545 KB",
        RisikenMenu: "Stand 02/2024 - PDF - 197 KB",
        EffectaKostenundZuwendungenMenu: "Stand 02/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 02/2024 - PDF - 167 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2024 - PDF - 208 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-FA-EA-01": {
        ZeichnungsscheinMenu: "Stand 02/2024 - PDF - 537 KB",
        RisikenMenu: "Stand 02/2024 - PDF - 195 KB",
        EffectaKostenundZuwendungenMenu: "Stand 02/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 02/2024 - PDF - 143 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2024 - PDF - 204 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-PE-SD-01": {
        ZeichnungsscheinMenu: "Stand 04/2024 - PDF - 552 KB",
        RisikenMenu: "Stand 04/2024 - PDF - 196 KB",
        EffectaKostenundZuwendungenMenu: "Stand 04/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 04/2024 - PDF - 218 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 04/2024 - PDF - 136 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-PE-SD-02": {
        ZeichnungsscheinMenu: "Stand 04/2024 - PDF - 554 KB",
        RisikenMenu: "Stand 04/2024 - PDF - 196 KB",
        EffectaKostenundZuwendungenMenu: "Stand 04/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 04/2024 - PDF - 219 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 04/2024 - PDF - 138 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-PE-SD-03": {
        ZeichnungsscheinMenu: "Stand 04/2024 - PDF - 549 KB",
        RisikenMenu: "Stand 04/2024 - PDF - 201 KB",
        EffectaKostenundZuwendungenMenu: "Stand 04/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 04/2024 - PDF - 218 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 04/2024 - PDF - 141 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-PE-SD-04": {
        ZeichnungsscheinMenu: "Stand 04/2024 - PDF - 559 KB",
        RisikenMenu: "Stand 04/2024 - PDF - 192 KB",
        EffectaKostenundZuwendungenMenu: "Stand 04/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 04/2024 - PDF - 221 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 04/2024 - PDF - 131 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "SACHWERT-05": {
        ZeichnungsscheinMenu: "Stand 05/2024 - PDF - 437 KB",
        RisikenMenu: "Stand 05/2024 - PDF - 115 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 05/2024 - PDF - 173 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2024 - PDF - 274 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-FA-TC-02": {
        ZeichnungsscheinMenu: "Stand 05/2024 - PDF - 337 KB",
        RisikenMenu: "Stand 05/2024 - PDF - 135 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 05/2024 - PDF - 163 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2024 - PDF - 275 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-FA-TC-03": {
        ZeichnungsscheinMenu: "Stand 05/2024 - PDF - 337 KB",
        RisikenMenu: "Stand 05/2024 - PDF - 135 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 05/2024 - PDF - 163 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2024 - PDF - 275 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-FA-TC-04": {
        ZeichnungsscheinMenu: "Stand 05/2024 - PDF - 339 KB",
        RisikenMenu: "Stand 05/2024 - PDF - 136 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 05/2024 - PDF - 161 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2024 - PDF - 270 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-FRD-01-01": {
        ZeichnungsscheinMenu: "Stand 06/2024 - PDF - 309 KB",
        RisikenMenu: "Stand 06/2024 - PDF - 139 KB",
        EffectaKostenundZuwendungenMenu: "Stand 06/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 06/2024 - PDF - 162 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2024 - PDF - 270 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-FRD-01-02": {
        ZeichnungsscheinMenu: "Stand 06/2024 - PDF - 304 KB",
        RisikenMenu: "Stand 06/2024 - PDF - 133 KB",
        EffectaKostenundZuwendungenMenu: "Stand 06/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 06/2024 - PDF - 163 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2024 - PDF - 270 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-FRD-01-03": {
        ZeichnungsscheinMenu: "Stand 06/2024 - PDF - 311 KB",
        RisikenMenu: "Stand 06/2024 - PDF - 141 KB",
        EffectaKostenundZuwendungenMenu: "Stand 06/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 06/2024 - PDF - 161 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2024 - PDF - 270 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "SI-AB-01": {
        ZeichnungsscheinMenu: "Stand 06/2024 - PDF - 511 KB",
        RisikenMenu: "Stand 06/2024 - PDF - 149 KB",
        EffectaKostenundZuwendungenMenu: "Stand 06/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 06/2024 - PDF - 181 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2024 - PDF - 290 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-SI-AB-01": {
        ZeichnungsscheinMenu: "Stand 06/2024 - PDF - 501 KB",
        RisikenMenu: "Stand 06/2024 - PDF - 159 KB",
        EffectaKostenundZuwendungenMenu: "Stand 06/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 06/2024 - PDF - 188 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2024 - PDF - 295 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-SI-AB-02": {
        ZeichnungsscheinMenu: "Stand 06/2024 - PDF - 501 KB",
        RisikenMenu: "Stand 06/2024 - PDF - 159 KB",
        EffectaKostenundZuwendungenMenu: "Stand 06/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 06/2024 - PDF - 188 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2024 - PDF - 295 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-SI-AB-03": {
        ZeichnungsscheinMenu: "Stand 06/2024 - PDF - 509 KB",
        RisikenMenu: "Stand 06/2024 - PDF - 159 KB",
        EffectaKostenundZuwendungenMenu: "Stand 06/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 06/2024 - PDF - 189 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2024 - PDF - 295 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "ASSETTA-03": {
        ZeichnungsscheinMenu: "Stand 07/2024 - PDF - 372 KB",
        RisikenMenu: "Stand 07/2024 - PDF - 215 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2024 - PDF - 143 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2024 - PDF - 163 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-ASSETTA-03-01": {
        ZeichnungsscheinMenu: "Stand 07/2024 - PDF - 375 KB",
        RisikenMenu: "Stand 07/2024 - PDF - 214 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2024 - PDF - 144 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2024 - PDF - 161 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-ASSETTA-03-02": {
        ZeichnungsscheinMenu: "Stand 07/2024 - PDF - 379 KB",
        RisikenMenu: "Stand 07/2024 - PDF - 214 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2024 - PDF - 149 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2024 - PDF - 163 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-ASSETTA-03-03": {
        ZeichnungsscheinMenu: "Stand 07/2024 - PDF - 369 KB",
        RisikenMenu: "Stand 07/2024 - PDF - 215 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2024 - PDF - 149 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2024 - PDF - 164 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-ASSETTA-03-04": {
        ZeichnungsscheinMenu: "Stand 07/2024 - PDF - 379 KB",
        RisikenMenu: "Stand 07/2024 - PDF - 214 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2024 - PDF - 149 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2024 - PDF - 163 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-ASSETTA-03-05": {
        ZeichnungsscheinMenu: "Stand 07/2024 - PDF - 376 KB",
        RisikenMenu: "Stand 07/2024 - PDF - 219 KB",
        EffectaKostenundZuwendungenMenu: "Stand 07/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 07/2024 - PDF - 149 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 07/2024 - PDF - 167 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "KALONUERNBERG-01": {
        ZeichnungsscheinMenu: "Stand 08/2024 - PDF - 657 KB",
        RisikenMenu: "Stand 08/2024 - PDF - 157 KB",
        EffectaKostenundZuwendungenMenu: "Stand 08/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 08/2024 - PDF - 187 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 08/2024 - PDF - 137 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-KALONUERNBERG-01-01": {
        ZeichnungsscheinMenu: "Stand 08/2024 - PDF - 659 KB",
        RisikenMenu: "Stand 08/2024 - PDF - 159 KB",
        EffectaKostenundZuwendungenMenu: "Stand 08/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 08/2024 - PDF - 187 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 08/2024 - PDF - 139 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-KALONUERNBERG-01-02": {
        ZeichnungsscheinMenu: "Stand 08/2024 - PDF - 651 KB",
        RisikenMenu: "Stand 08/2024 - PDF - 159 KB",
        EffectaKostenundZuwendungenMenu: "Stand 08/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 08/2024 - PDF - 188 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 08/2024 - PDF - 131 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-KALONUERNBERG-01-03": {
        ZeichnungsscheinMenu: "Stand 08/2024 - PDF - 652 KB",
        RisikenMenu: "Stand 08/2024 - PDF - 162 KB",
        EffectaKostenundZuwendungenMenu: "Stand 08/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 08/2024 - PDF - 187 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 08/2024 - PDF - 142 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-KALONUERNBERG-01-04": {
        ZeichnungsscheinMenu: "Stand 08/2024 - PDF - 650 KB",
        RisikenMenu: "Stand 08/2024 - PDF - 161 KB",
        EffectaKostenundZuwendungenMenu: "Stand 08/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 08/2024 - PDF - 187 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 08/2024 - PDF - 144 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-KALONUERNBERG-01-05": {
        ZeichnungsscheinMenu: "Stand 08/2024 - PDF - 654 KB",
        RisikenMenu: "Stand 08/2024 - PDF - 160 KB",
        EffectaKostenundZuwendungenMenu: "Stand 08/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 08/2024 - PDF - 187 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 08/2024 - PDF - 143 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-DE-HH-12": {
        ZeichnungsscheinMenu: "Stand 09/2024 - PDF - 654 KB",
        RisikenMenu: "Stand 09/2024 - PDF - 160 KB",
        EffectaKostenundZuwendungenMenu: "Stand 09/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 09/2024 - PDF - 187 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 09/2024 - PDF - 143 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "LOUIS-01": {
        ZeichnungsscheinMenu: "Stand 09/2024 - PDF - 601 KB",
        RisikenMenu: "Stand 09/2024 - PDF - 122 KB",
        EffectaKostenundZuwendungenMenu: "Stand 09/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 09/2024 - PDF - 115 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 09/2024 - PDF - 143 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-LOUIS-01-01": {
        ZeichnungsscheinMenu: "Stand 09/2024 - PDF - 608 KB",
        RisikenMenu: "Stand 09/2024 - PDF - 122 KB",
        EffectaKostenundZuwendungenMenu: "Stand 09/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 09/2024 - PDF - 115 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 09/2024 - PDF - 143 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-LOUIS-01-02": {
        ZeichnungsscheinMenu: "Stand 09/2024 - PDF - 602 KB",
        RisikenMenu: "Stand 09/2024 - PDF - 115 KB",
        EffectaKostenundZuwendungenMenu: "Stand 09/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 09/2024 - PDF - 167 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 09/2024 - PDF - 143 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-AREL-01-01": {
        ZeichnungsscheinMenu: "Stand 10/2024 - PDF - 488 KB",
        RisikenMenu: "Stand 10/2024 - PDF - 128 KB",
        EffectaKostenundZuwendungenMenu: "Stand 10/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 10/2024 - PDF - 155 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 10/2024 - PDF - 145 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-AREL-01-02": {
        ZeichnungsscheinMenu: "Stand 10/2024 - PDF - 489 KB",
        RisikenMenu: "Stand 10/2024 - PDF - 127 KB",
        EffectaKostenundZuwendungenMenu: "Stand 10/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 10/2024 - PDF - 156 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 10/2024 - PDF - 146 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-AREL-02-02": {
        ZeichnungsscheinMenu: "Stand 10/2024 - PDF - 481 KB",
        RisikenMenu: "Stand 10/2024 - PDF - 139 KB",
        EffectaKostenundZuwendungenMenu: "Stand 10/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 10/2024 - PDF - 166 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 10/2024 - PDF - 156 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-AREL-02-02": {
        ZeichnungsscheinMenu: "Stand 10/2024 - PDF - 489 KB",
        RisikenMenu: "Stand 10/2024 - PDF - 131 KB",
        EffectaKostenundZuwendungenMenu: "Stand 10/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 10/2024 - PDF - 161 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 10/2024 - PDF - 194 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-AREL-02-03": {
        ZeichnungsscheinMenu: "Stand 10/2024 - PDF - 465 KB",
        RisikenMenu: "Stand 10/2024 - PDF - 130 KB",
        EffectaKostenundZuwendungenMenu: "Stand 10/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 10/2024 - PDF - 153 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 10/2024 - PDF - 151 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-FRD-02-01": {
        ZeichnungsscheinMenu: "Stand 11/2024 - PDF - 311 KB",
        RisikenMenu: "Stand 11/2024 - PDF - 141 KB",
        EffectaKostenundZuwendungenMenu: "Stand 11/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 11/2024 - PDF - 161 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2024 - PDF - 270 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-FRD-02-02": {
        ZeichnungsscheinMenu: "Stand 11/2024 - PDF - 211 KB",
        RisikenMenu: "Stand 11/2024 - PDF - 149 KB",
        EffectaKostenundZuwendungenMenu: "Stand 11/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 11/2024 - PDF - 163 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2024 - PDF - 270 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-FRD-02-03": {
        ZeichnungsscheinMenu: "Stand 11/2024 - PDF - 211 KB",
        RisikenMenu: "Stand 11/2024 - PDF - 151 KB",
        EffectaKostenundZuwendungenMenu: "Stand 11/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 11/2024 - PDF - 163 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2024 - PDF - 273 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-FRD-02-04": {
        ZeichnungsscheinMenu: "Stand 11/2024 - PDF - 217 KB",
        RisikenMenu: "Stand 11/2024 - PDF - 169 KB",
        EffectaKostenundZuwendungenMenu: "Stand 11/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 11/2024 - PDF - 183 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2024 - PDF - 270 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "NEU26-01": {
        ZeichnungsscheinMenu: "Stand 12/2024 - PDF - 213 KB",
        RisikenMenu: "Stand 12/2024 - PDF - 163 KB",
        EffectaKostenundZuwendungenMenu: "Stand 12/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 12/2024 - PDF - 183 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2024 - PDF - 270 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-NEU26-01-01": {
        ZeichnungsscheinMenu: "Stand 12/2024 - PDF - 217 KB",
        RisikenMenu: "Stand 12/2024 - PDF - 169 KB",
        EffectaKostenundZuwendungenMenu: "Stand 12/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 12/2024 - PDF - 183 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2024 - PDF - 270 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-NEU26-01-02": {
        ZeichnungsscheinMenu: "Stand 12/2024 - PDF - 227 KB",
        RisikenMenu: "Stand 12/2024 - PDF - 176 KB",
        EffectaKostenundZuwendungenMenu: "Stand 12/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 12/2024 - PDF - 184 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2024 - PDF - 270 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "SACHWERT-06": {
        ZeichnungsscheinMenu: "Stand 12/2024 - PDF - 237 KB",
        RisikenMenu: "Stand 12/2024 - PDF - 179 KB",
        EffectaKostenundZuwendungenMenu: "Stand 12/2024 - PDF - 97 KB",
        BasisinformationsblattMenu: "Stand 12/2024 - PDF - 185 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2024 - PDF - 271 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 140 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "SACHWERT-07": {
        ZeichnungsscheinMenu: "Stand 05/2025 - PDF - 964 KB",
        RisikenMenu: "Stand 05/2025 - PDF - 122 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2025 - PDF - 68 KB",
        BasisinformationsblattMenu: "Stand 05/2025 - PDF - 164 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 05/2025 - PDF - 228 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 133 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-TO-01": {
        ZeichnungsscheinMenu: "Stand 11/2024 - PDF - 964 KB",
        RisikenMenu: "Stand 11/2024 - PDF - 122 KB",
        EffectaKostenundZuwendungenMenu: "Stand 11/2024 - PDF - 68 KB",
        BasisinformationsblattMenu: "Stand 11/2024 - PDF - 164 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 11/2024 - PDF - 228 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 133 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-TO-01-01": {
        ZeichnungsscheinMenu: "Stand 11/2024 - PDF - 964 KB",
        RisikenMenu: "Stand 11/2024 - PDF - 122 KB",
        EffectaKostenundZuwendungenMenu: "Stand 11/2024 - PDF - 68 KB",
        BasisinformationsblattMenu: "Stand 11/2024 - PDF - 164 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 11/2024 - PDF - 228 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 133 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-TO-01-02": {
        ZeichnungsscheinMenu: "Stand 11/2024 - PDF - 964 KB",
        RisikenMenu: "Stand 11/2024 - PDF - 122 KB",
        EffectaKostenundZuwendungenMenu: "Stand 11/2024 - PDF - 68 KB",
        BasisinformationsblattMenu: "Stand 11/2024 - PDF - 164 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 11/2024 - PDF - 228 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 133 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-TO-01-03": {
        ZeichnungsscheinMenu: "Stand 11/2024 - PDF - 964 KB",
        RisikenMenu: "Stand 11/2024 - PDF - 122 KB",
        EffectaKostenundZuwendungenMenu: "Stand 11/2024 - PDF - 68 KB",
        BasisinformationsblattMenu: "Stand 11/2024 - PDF - 164 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 11/2024 - PDF - 228 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 133 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-TO-02": {
        ZeichnungsscheinMenu: "Stand 02/2025 - PDF - 964 KB",
        RisikenMenu: "Stand 02/2025 - PDF - 122 KB",
        EffectaKostenundZuwendungenMenu: "Stand 02/2025 - PDF - 68 KB",
        BasisinformationsblattMenu: "Stand 02/2025 - PDF - 164 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2025 - PDF - 228 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 133 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-TO-02-01": {
        ZeichnungsscheinMenu: "Stand 02/2025 - PDF - 964 KB",
        RisikenMenu: "Stand 02/2025 - PDF - 122 KB",
        EffectaKostenundZuwendungenMenu: "Stand 02/2025 - PDF - 68 KB",
        BasisinformationsblattMenu: "Stand 02/2025 - PDF - 164 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2025 - PDF - 228 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 133 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-TO-02-02": {
        ZeichnungsscheinMenu: "Stand 02/2025 - PDF - 964 KB",
        RisikenMenu: "Stand 02/2025 - PDF - 122 KB",
        EffectaKostenundZuwendungenMenu: "Stand 02/2025 - PDF - 68 KB",
        BasisinformationsblattMenu: "Stand 02/2025 - PDF - 164 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 02/2025 - PDF - 228 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 133 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-FINCHAIN-01": {
        ZeichnungsscheinMenu: "Stand 01/2025 - PDF - 964 KB",
        RisikenMenu: "Stand 01/2025 - PDF - 122 KB",
        EffectaKostenundZuwendungenMenu: "Stand 01/2025 - PDF - 68 KB",
        BasisinformationsblattMenu: "Stand 01/2025 - PDF - 164 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 01/2025 - PDF - 228 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 133 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-FINCHAIN-01-01": {
        ZeichnungsscheinMenu: "Stand 01/2025 - PDF - 964 KB",
        RisikenMenu: "Stand 01/2025 - PDF - 122 KB",
        EffectaKostenundZuwendungenMenu: "Stand 01/2025 - PDF - 68 KB",
        BasisinformationsblattMenu: "Stand 01/2025 - PDF - 164 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 01/2025 - PDF - 228 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 133 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-FINCHAIN-01-02": {
        ZeichnungsscheinMenu: "Stand 01/2025 - PDF - 964 KB",
        RisikenMenu: "Stand 01/2025 - PDF - 122 KB",
        EffectaKostenundZuwendungenMenu: "Stand 01/2025 - PDF - 68 KB",
        BasisinformationsblattMenu: "Stand 01/2025 - PDF - 164 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 01/2025 - PDF - 228 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 133 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-LIGHT-01": {
        ZeichnungsscheinMenu: "Stand 03/2025 - PDF - 964 KB",
        RisikenMenu: "Stand 03/2025 - PDF - 122 KB",
        EffectaKostenundZuwendungenMenu: "Stand 03/2025 - PDF - 68 KB",
        BasisinformationsblattMenu: "Stand 03/2025 - PDF - 164 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 03/2025 - PDF - 228 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 133 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-LIGHT-01-01": {
        ZeichnungsscheinMenu: "Stand 03/2025 - PDF - 964 KB",
        RisikenMenu: "Stand 03/2025 - PDF - 122 KB",
        EffectaKostenundZuwendungenMenu: "Stand 03/2025 - PDF - 68 KB",
        BasisinformationsblattMenu: "Stand 03/2025 - PDF - 164 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 03/2025 - PDF - 228 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 133 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-LIGHT-01-02": {
        ZeichnungsscheinMenu: "Stand 03/2025 - PDF - 964 KB",
        RisikenMenu: "Stand 03/2025 - PDF - 122 KB",
        EffectaKostenundZuwendungenMenu: "Stand 03/2025 - PDF - 68 KB",
        BasisinformationsblattMenu: "Stand 03/2025 - PDF - 164 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 03/2025 - PDF - 228 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 133 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-LIGHT-01-03": {
        ZeichnungsscheinMenu: "Stand 03/2025 - PDF - 964 KB",
        RisikenMenu: "Stand 03/2025 - PDF - 122 KB",
        EffectaKostenundZuwendungenMenu: "Stand 03/2025 - PDF - 68 KB",
        BasisinformationsblattMenu: "Stand 03/2025 - PDF - 164 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 03/2025 - PDF - 228 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 133 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "UK-UNP-01": {
        ZeichnungsscheinMenu: "Stand 05/2025 - PDF - 964 KB",
        RisikenMenu: "Stand 05/2025 - PDF - 122 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2025 - PDF - 68 KB",
        BasisinformationsblattMenu: "Stand 05/2025 - PDF - 164 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 05/2025 - PDF - 228 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 133 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-UK-UNP-01-01": {
        ZeichnungsscheinMenu: "Stand 05/2025 - PDF - 964 KB",
        RisikenMenu: "Stand 05/2025 - PDF - 122 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2025 - PDF - 68 KB",
        BasisinformationsblattMenu: "Stand 05/2025 - PDF - 164 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 05/2025 - PDF - 228 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 133 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-UK-UNP-01-02": {
        ZeichnungsscheinMenu: "Stand 05/2025 - PDF - 964 KB",
        RisikenMenu: "Stand 05/2025 - PDF - 122 KB",
        EffectaKostenundZuwendungenMenu: "Stand 05/2025 - PDF - 68 KB",
        BasisinformationsblattMenu: "Stand 05/2025 - PDF - 164 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 05/2025 - PDF - 228 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 133 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-DE-IREINVEST-01-01": {
        ZeichnungsscheinMenu: "Stand 04/2025 - PDF - 964 KB",
        RisikenMenu: "Stand 04/2025 - PDF - 122 KB",
        EffectaKostenundZuwendungenMenu: "Stand 04/2025 - PDF - 68 KB",
        BasisinformationsblattMenu: "Stand 04/2025 - PDF - 164 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 04/2025 - PDF - 228 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 133 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "DE-IREINVEST-02": {
        ZeichnungsscheinMenu: "Stand 06/2025 - PDF - 964 KB",
        RisikenMenu: "Stand 06/2025 - PDF - 122 KB",
        EffectaKostenundZuwendungenMenu: "Stand 06/2025 - PDF - 68 KB",
        BasisinformationsblattMenu: "Stand 06/2025 - PDF - 164 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 06/2025 - PDF - 228 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 133 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-DE-IREINVEST-02-01": {
        ZeichnungsscheinMenu: "Stand 06/2025 - PDF - 964 KB",
        RisikenMenu: "Stand 06/2025 - PDF - 122 KB",
        EffectaKostenundZuwendungenMenu: "Stand 06/2025 - PDF - 68 KB",
        BasisinformationsblattMenu: "Stand 06/2025 - PDF - 164 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 06/2025 - PDF - 228 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 133 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-DE-IREINVEST-02-02": {
        ZeichnungsscheinMenu: "Stand 06/2025 - PDF - 964 KB",
        RisikenMenu: "Stand 06/2025 - PDF - 122 KB",
        EffectaKostenundZuwendungenMenu: "Stand 06/2025 - PDF - 68 KB",
        BasisinformationsblattMenu: "Stand 06/2025 - PDF - 164 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 06/2025 - PDF - 228 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 133 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-DE-IREINVEST-02-03": {
        ZeichnungsscheinMenu: "Stand 06/2025 - PDF - 964 KB",
        RisikenMenu: "Stand 06/2025 - PDF - 122 KB",
        EffectaKostenundZuwendungenMenu: "Stand 06/2025 - PDF - 68 KB",
        BasisinformationsblattMenu: "Stand 06/2025 - PDF - 164 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 06/2025 - PDF - 228 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 133 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-DE-IREINVEST-02-04": {
        ZeichnungsscheinMenu: "Stand 06/2025 - PDF - 964 KB",
        RisikenMenu: "Stand 06/2025 - PDF - 122 KB",
        EffectaKostenundZuwendungenMenu: "Stand 06/2025 - PDF - 68 KB",
        BasisinformationsblattMenu: "Stand 06/2025 - PDF - 164 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 06/2025 - PDF - 228 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 133 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
    "CD-PP-DE-IREINVEST-02-05": {
        ZeichnungsscheinMenu: "Stand 06/2025 - PDF - 964 KB",
        RisikenMenu: "Stand 06/2025 - PDF - 122 KB",
        EffectaKostenundZuwendungenMenu: "Stand 06/2025 - PDF - 68 KB",
        BasisinformationsblattMenu: "Stand 06/2025 - PDF - 164 KB",
        SchuldverschreibungsbedingungenMenu: "Stand 06/2025 - PDF - 228 KB",
        EffectaAGBMenu: "Stand 03/2023 - PDF - 133 KB",
        EffectaConsumerInformationMenu: "Stand 05/2022 - PDF - 132 KB",
    },
};
